<template>
	<div class="d-flex flex-1">
		<v-card class="report-container w-100  p-0" style="border-radius: 12px; margin-bottom: 24px">
			<v-toolbar class="shadow-none" style="flex: unset;" content-class="h-auto">
                <div class="custom-icon-wrapper">
                    <v-icon @click="backToAdminPage()">custom-icon left-arrow-icon</v-icon>
                </div>
                <v-toolbar-title class="size-16 dark-text">Manage Actions</v-toolbar-title>
            </v-toolbar>
            <div>
				<v-card-title>
					<div class="border-top flex-1 overflow-auto text-end" style="padding-top: 5px;">
						<v-btn @click="showAddDialog" width="200px" color="primary">Add Action</v-btn>
					</div>
				</v-card-title>
			</div>
			<div class="d-flex flex-1 flex-column overflow-auto" style="padding: 5px">
				<v-data-table :headers="headers" :items="items" :items-per-page="-1" disable-sort hide-default-footer class="elevation-1">
					<template v-slot:item="row">
						<tr>
							<td>{{row.item.name}}</td>
							<td>{{showtext(row.item.type)}}</td>
							<td>{{showApplicationText(row.item.applicationId)}}</td>
							<td>{{row.item.order}}</td>
                            <td>{{row.item.icon}}</td>
                            <td>{{row.item.tooltip}}</td>
							<td class="text-start">
								<div class="onhover-display">
									<div class="custom-icon-wrapper">
										<v-icon small @click="editItem(row.item)">custom-icon white-bg edit-icon</v-icon>
									</div>
									<div class="custom-icon-wrapper">
										<v-icon small @click="openDeleteDialog(row.item)">custom-icon white-bg delete-icon</v-icon>
									</div>
								</div>
							</td>
						</tr>
					</template>
				</v-data-table>
			</div>
		</v-card>
		<v-dialog v-model="addDialogVisible" max-width="500px" >
			<v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">
						<span v-if="editedItem.id">Edit Action</span>
                        <span v-else>Add Action</span></v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="addDialogVisible = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <div class="d-flex flex-column overflow-auto h-100">
                   <div class="grid-12 flex-1 p-4 overflow-auto gap-2">
						<v-row>
							<v-col cols="12">
								<v-label>Name *</v-label>
                                <v-text-field solo v-model="editedItem.name" ></v-text-field>
							</v-col>
							<v-col cols="6" sm="6">
								<v-label>Type *</v-label>
                                <v-select v-model="editedItem.type" :items="selectValue" solo ></v-select>
							</v-col>
							<v-col cols="6" sm="6">
								<v-label>Application *</v-label>
                                <v-select v-model="editedItem.applicationId" :items="applications" item-text="name" item-value="id" solo ></v-select>
							</v-col>
							<v-col cols="6" sm="6">
								<v-label>Order</v-label>
								<v-text-field solo v-model="editedItem.order" type="number"></v-text-field>
							</v-col>
							<v-col cols="6" sm="6">
                                <v-label>Icon</v-label>
								<v-text-field solo v-model="editedItem.icon"></v-text-field>
							</v-col>
                            <v-col cols="6" sm="6">
                                <v-label>Tooltip</v-label>
								<v-text-field solo v-model="editedItem.tooltip"></v-text-field>
							</v-col>
						</v-row>
					</div>
					<v-card-actions class="gap-2 sticky-actions">
						<v-spacer></v-spacer>
						<v-btn class="light-blue" style="min-width: 100px !important;" @click="cancelAddDialog()">{{ $t("res_ButtonText_Cancel") }}</v-btn>
						<v-btn class="primary" style="min-width: 100px !important;" @click="upsertItem(editedItem)">{{ $t("res_ButtonText_Continue") }}</v-btn>
					</v-card-actions>
				</div>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import axios from "axios"
import constants from "@/assets/js/constants.js"
import router from '@/router/index.js'
import ActionSecurityRole from '@/components/ActionSecurityRole.vue'

export default {
    components: { ActionSecurityRole },
	data() {
		return {
			headers: [
				{ text: "Name",    value: "name",      align: "start",   width: "20%"   },
				{ text: "Type",    value: "type",      align: "start",   width: "10%"   },
				{ text: "Application",    value: "applicationId",      align: "start",   width: "10%"   },
				{ text: "Order",   value: "order",     align: "start",   width: "10%"   },
                { text: "Icon",    value: "icon",      align: "start",   width: "20%"   },
                { text: "Tooltip", value: "tooltip",   align: "start",   width: "20%"   },
				{ text: "Actions", value: "actions",   align: "start",   width: "10%"   },
			],
			items: [],
            selectValue: [
				{ text: 'Menu', value: 1 }, 
				{ text: 'Toolbar Menu', value: 2 }, 
				{ text: 'Feature', value: 3},
				{ text: 'Reports', value: 4 } 
            ],
			applications:[],
            types: { 1: 'Menu', 2: 'Toolbar Menu', 3: 'Feature', 4: 'Reports'},
			addDialogVisible: false,
			editedItem: {
                id: 0,
			    name: "",
				type: null,
				order: null,
				icon: "",
				tooltip: "",
				applicationId: 0
			},
			editedRoleId: 0
		};
	},
	methods: {
		backToAdminPage()
		{
            router.push({ name: 'admin' })
        },
        showtext(value){
            return this.types[value]
        },
		showApplicationText(value)
		{
			return this.applications.find(app => app.id == value).name;
		},
		async fetchData() 
		{
			this.applications = window.applications

			const res = await axios
				.get(constants.baseApiUrl + "ActionSecurity/GetActions")
				.then((res) => {
					this.items = res.data;
				})
				.catch((error) => console.error("Error fetching data:", error));
		},
		showAddDialog() 
		{
			this.addDialogVisible = true
			this.editedItem = {id:0, name:"", type:null, order: null, icon:"", tooltip:"", applicationId: null }
		},
		editItem(item) 
		{
			this.editedItem = item
			this.addDialogVisible = true
		},
		async upsertItem(item)
		{
            if(this.editedItem.id==0)
            {
            if (this.editedItem.name.trim() == "" || this.editedItem.type == null)
			{
				window.showAlert('res_Msgs_FillRequired', 'warning')
				return
			}
            }
			if (this.editedItem.id == 0)
			{
				var Actionobj = {id:0, name:this.editedItem.name, type:this.editedItem.type, order:this.editedItem.order,
                icon:this.editedItem.icon,tooltip:this.editedItem.tooltip, applicationId: this.editedItem.applicationId}

				await axios.post(constants.baseApiUrl + "ActionSecurity/AddNewAction",Actionobj)
					.then((res) => this.cancelAddDialog())
					.catch((err) => console.error("Error creating item:", err));
			}
			else
			{
				var Actionobj = {id:this.editedItem.id, name:this.editedItem.name, type:this.editedItem.type, order:this.editedItem.order,
                icon:this.editedItem.icon,tooltip:this.editedItem.tooltip, applicationId: this.editedItem.applicationId }

				await axios.post(constants.baseApiUrl + "ActionSecurity/UpdateAction?id="+item.id, Actionobj)
					.then((res) => this.cancelAddDialog())
					.catch((err) => console.error("Error Updating item:", err));
			}
		},
		cancelAddDialog() 
		{
			this.addDialogVisible = false
            this.editedItem.id = null
            this.editedItem.name = ""
            this.editedItem.type = null
            this.editedItem.order = null
            this.editedItem.icon = ""
            this.editedItem.tooltip = ""
			this.editedItem.applicationId = null
			this.fetchData()
		},
		openDeleteDialog(item) 
		{
            window.showInformation(this.$t('res_Label_Alert'), this.$t("res_Msgs_DeletConfirmation"),
                () => 
				{
					axios.get(constants.baseApiUrl + "ActionSecurity/DeleteAction?id=" + item.id)
						.then((res) => this.fetchData())
						.catch((err) => console.log(err));
                },
                () => { })
		},
	},
    mounted() 
	{
		this.fetchData()
	},
};
</script>